import { render } from "./document_management.html?vue&type=template&id=6f69f85a&scoped=true&external"
import script from "./document_management.js?vue&type=script&lang=js&external"
export * from "./document_management.js?vue&type=script&lang=js&external"

import "./DocumentManagement.vue?vue&type=style&index=0&id=6f69f85a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f69f85a"]])

export default __exports__